<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Trenches</h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="/">Settings</a>
                                </li>
                                <li class="breadcrumb-item active">Trenches</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right ml-1" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add Trench</span></button>
                    
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showCreatePanel">
                            <div class="card-header">
                                <h4 class="card-title">Add Trench</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <trench-form @completed="getTrenches" @cancel="showCreatePanel = !showCreatePanel"></trench-form>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterTrenchForm.keyword">
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="trenches.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterTrenchForm.sort_by" :order="filterTrenchForm.order" @updateSortBy="value => {filterTrenchForm.sort_by = value}"  @updateOrder="value => {filterTrenchForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="trenches.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Class</th>
                                            <th>Term</th>
                                            <th>Name</th>
                                            <th>Amount</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="trench in trenches.data">
                                            <td v-text="trench.clas.name"></td>
                                            <td v-text="trench.term.name"></td>
                                            <td v-text="trench.name"></td>
                                            <td>{{ trench.amount | formatMoney }}</td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <button class="btn btn-info btn-sm" v-tooltip="'Edit Trench'" @click.prevent="editTrench(trench)"><i class="feather icon-edit"></i></button>
                                                    <button class="btn btn-danger btn-sm" :key="trench.id" v-confirm="{ok: confirmDelete(trench)}" v-tooltip="'Delete Trench'"><i class="feather icon-trash-2"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!trenches.total"  module="general" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" v-if="!showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterTrenchForm.page_length" :records="trenches" @updateRecords="getTrenches"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import trenchForm from './form'
    import sortBy from '../../../components/sort-by'

    export default {
        components : { trenchForm,sortBy },
        data() {
            return {
                trenches: {
                    total: 0,
                    data: []
                },
                filterTrenchForm: {
                    keyword: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'cycle_id',
                        translation: 'Cycle'
                    },
                    {
                        value: 'name',
                        translation: 'Name'
                    }
                ],
                showCreatePanel: false,
                showFilterPanel: false
            };
        },
        mounted(){
            if(!helper.hasPermission('access-settings')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getTrenches();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getTrenches(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterTrenchForm);
                axios.get('/api/setting/trench?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.trenches = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editTrench(trench){
                this.$router.push('/setting/trench/'+trench.id+'/edit');
            },
            confirmDelete(trench){
                return dialog => this.deleteTrench(trench);
            },
            deleteTrench(trench){
                axios.delete('/api/setting/trench/'+trench.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getTrenches();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        },
        watch: {
            filterTrenchForm: {
                handler(val){
                    setTimeout(() => {
                        this.getTrenches();
                    }, 500)
                },
                deep: true
            }
        },

        filters: {
          formatMoney(value) {
            return helper.formatMoney(value);
          }
        }
    }
</script>
